import { useEffect, type ReactNode } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { adminMutation, clearAdminApiState } from "../../lib/adminApi";
import { Button } from "../Button";

export function AdminShell({ children, title, backHref, backLabel = "Back to submissions" }: { children: ReactNode; title: string; backHref?: string; backLabel?: string }) {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const existing = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    const meta = existing ?? document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow,noarchive";
    if (!existing) document.head.append(meta);
    return () => { if (!existing) meta.remove(); };
  }, []);
  const signOut = async () => {
    try { await adminMutation("/api/admin/auth/logout", "POST"); } finally { clearAdminApiState(); navigate("/admin/login", { replace: true }); }
  };
  return (
    <div className="admin-page">
      <header className="admin-header">
        <div className="admin-brand-lockup">
          <Link className="wordmark" to="/admin/submissions">HuddleCo</Link>
          <span className="admin-product">Friction Finder internal</span>
        </div>
        <nav className="admin-nav" aria-label="Internal navigation">
          <Link className="admin-nav-link" to="/admin/submissions" aria-current={location.pathname.startsWith("/admin/submissions") ? "page" : undefined}>Submissions</Link>
          <Link className="admin-nav-link" to="/admin/team" aria-current={location.pathname.startsWith("/admin/team") ? "page" : undefined}>Team</Link>
          <Button variant="text" onClick={signOut}>Sign out</Button>
        </nav>
      </header>
      <main className="admin-main">
        <div className="admin-page-heading">
          {backHref && <Link className="back-link" to={backHref}>← {backLabel}</Link>}
          <p className="eyebrow">Internal workspace</p>
          <h1>{title}</h1>
        </div>
        {children}
      </main>
    </div>
  );
}
